import React from "react"
import { NumberTagFieldSeeker } from "@ui-seeker/core"

import { rentalLength } from "@signals"


export default function AppCommonFiltersRentalLengthTags({ ...props }) {
	return <NumberTagFieldSeeker
		label="Rental length"
		placeholder="Select rental length"
		value={rentalLength.value}
		onChange={e => rentalLength.value = e}
		{...props}
	/>
}